import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Icon, Dropdown, Dimmer } from "semantic-ui-react";
import SRHHeader from "./../index";
import { HeaderLeft, HeaderCenter, HeaderRight, HeaderTab, Logo, Title, Breadcrumb, DimmerStyle } from "./style.js";
import logo from "./../../../assets/img/logo/logo-white.png";
import { userOperations } from "./../../../redux/user";
import { magnetReportOperations } from "./../../../redux/magnetReport";
import { navActions } from "./../../../redux/nav";
import moment from "moment";
import ReactGA from "react-ga";
import Snackbar from "../../Snackbar";

ReactGA.initialize("UA-52754256-15");

class MagnetReportHeader extends Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
    this.print = this.print.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  download() {
    const { datasetName, survey, surveyPeriod } = this.props.magnetReport;
    const { unit, dispatch } = this.props;

    let action;
    let filename;
    if (unit === "facility") {
      action = "save_facility_magnet_report";
      filename = `MAGNET_Questions_Report_${datasetName}_${surveyPeriod}_${moment().format("MMDDYYYY")}.pdf`;
    } else if (unit) {
      action = "save_unit_magnet_report";
      filename = `MAGNET_Report_${datasetName}_${unit}_${surveyPeriod}_${moment().format("MMDDYYYY")}.pdf`;
    } else {
      action = "save_magnet_report";
      filename = `MAGNET_Report_${datasetName}_${surveyPeriod}_${moment().format("MMDDYYYY")}.pdf`;
    }

    ReactGA.event({
      category: datasetName,
      action,
      label: filename,
    });

    const oldIframe = document.getElementById("downloadIFrame");
    if (oldIframe) {
      oldIframe.remove();
    }

    const iframe = document.createElement("iframe");
    iframe.name = "downloadFrame";
    iframe.id = "downloadIFrame";
    iframe.style.display = "none";
    iframe.src = "";
    document.body.appendChild(iframe);

    const oldForm = document.getElementById("form");
    if (oldForm) {
      oldForm.remove();
    }

    const form = document.createElement("form");
    form.id = "form";
    form.method = "post";
    form.action = "https://reports.safeandreliablecare.com/api/pdf";
    form.target = "downloadFrame";
    document.body.appendChild(form);

    const filenameInput = document.createElement("input");
    filenameInput.type = "hidden";
    filenameInput.name = "filename";
    filenameInput.value = filename;
    form.appendChild(filenameInput);

    const htmlInput = document.createElement("input");
    htmlInput.type = "hidden";
    htmlInput.name = "html";
    if (window.location.protocol === "https:") {
      htmlInput.value = document.documentElement.innerHTML.replace(
        /\/static\//g,
        `https://${window.location.host}/static/`
      );
    } else {
      htmlInput.value = document.documentElement.innerHTML.replace(
        /\/static\//g,
        `https://reports.us.safeandreliablecare.com/static/`
      );
    }
    // const head = document.getElementsByTagName("head")[0].innerHTML;
    // const divToPrint = document.getElementById("divToPrint").innerHTML;
    // html.value = `<html>${head}<body>${divToPrint}</body></html>`;
    form.appendChild(htmlInput);

    form.submit();
    dispatch(navActions.setSnackbarOptions({ message: "Downloading report" }));
  }

  print() {
    const { datasetName, survey } = this.props.magnetReport;
    const { unit } = this.props;
    let label;
    if (unit === "facility") {
      label = `MAGNET_Questions_Report_${datasetName}_${moment().format("MMDDYYYY")}.pdf`;
    } else if (unit) {
      label = `MAGNET_Report_${datasetName}_${unit}_${moment().format("MMDDYYYY")}.pdf`;
    } else {
      label = `MAGNET_Report_${datasetName}_${moment().format("MMDDYYYY")}.pdf`;
    }
    ReactGA.event({
      category: datasetName,
      action: "print_report",
      label,
    });
    window.print();
  }

  signOut() {
    this.props.dispatch(userOperations.signOut());
    this.props.dispatch(magnetReportOperations.clear());
  }

  render() {
    const { breadcrumbs, units, ready, magnetReport, nav } = this.props;
    const datasetUnitName = magnetReport.datasetUnitNamePlural ? magnetReport.datasetUnitNamePlural : "Work Settings";
    return (
      <SRHHeader>
        <Snackbar />
        <HeaderLeft>
          <HeaderTab style={{ zIndex: "2" }}>
            <Logo className="logo">
              <img src={logo} alt="" />
            </Logo>
            <Title className="add-background">
              Survey <br /> Results
            </Title>
          </HeaderTab>
          {breadcrumbs &&
            breadcrumbs.length > 0 && (
              <HeaderTab style={{ zIndex: "1" }}>
                <Breadcrumb key="breadcrumb-1">{breadcrumbs[0]}</Breadcrumb>
              </HeaderTab>
            )}
          {breadcrumbs &&
            breadcrumbs.length > 1 &&
            (units.length > 1 && ready ? (
              <Breadcrumb key="breadcrumb-2" style={{ paddingLeft: "30px", zIndex: 1000 }}>
                <Dropdown
                  search
                  selection
                  options={units}
                  value={breadcrumbs[1]}
                  onChange={(event, data) => this.props.setUnit(data.value)}
                />
              </Breadcrumb>
            ) : breadcrumbs[1] === "magnet" ? (
              <Breadcrumb key="breadcrumb-2">ANCC MAGNET Report</Breadcrumb>
            ) : breadcrumbs[1] === "facility" ? (
              <Breadcrumb key="breadcrumb-2">All Surveyed {datasetUnitName}</Breadcrumb>
            ) : (
              <Breadcrumb key="breadcrumb-2">{breadcrumbs[1]}</Breadcrumb>
            ))}
        </HeaderLeft>
        <HeaderCenter />
        <Dimmer.Dimmable as={HeaderRight} dimmed={!ready}>
          <Dimmer as={DimmerStyle} active={!ready} />
          <Button secondary onClick={this.download}>
            Download/Print report <Icon name="download" />
          </Button>
          <Button primary onClick={this.print} style={{ display: "none" }}>
            <Icon name="print" size="large" />
          </Button>
          <Button primary onClick={this.signOut} style={{ whiteSpace: "nowrap", display: "none" }}>
            Sign out
          </Button>
        </Dimmer.Dimmable>
      </SRHHeader>
    );
  }
}

export default connect(store => {
  return {
    nav: store.nav
  };
})(withRouter(MagnetReportHeader));



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/MagnetReportHeader/index.jsx